<div class="container">
  <div *ngIf="isScaleUsingInProducts()">
    <div style="margin-bottom: 10px">{{ 'MENU.SIZE_SCALES.SIZE_SCALE_USE_IN' | translate }}</div>
    <div *ngFor="let productName of usingScalesInProducts" style="text-align: center">
      {{ productName }}
    </div>

    <div style="margin-top: 10px; max-width: 500px">
      {{ 'MENU.SIZE_SCALES.CONFIRM_TEXT' | translate }}
    </div>
  </div>

  <div *ngIf="!isScaleUsingInProducts()">
    <div style="margin-bottom: 10px">
      {{ 'MENU.SIZE_SCALES.SIZE_SCALE_DONT_USE' | translate }}
    </div>
  </div>

  <div style="margin-bottom: 10px; margin-top: 10px;">{{ 'MENU.SIZE_SCALES.SURE_DELETE' | translate }}</div>
  <div style="display: flex">
    <button
      mat-button
      type="button"
      (click)="delete()"
      style="flex: auto"
    >{{ 'MENU.DELETE' | translate }}
    </button>
    <button
      type="button"
      mat-button
      class="mat-button-primary"
      type="button"
      (click)="cancel()"
      style="flex: auto"
      tabindex="-1"
    >{{ 'MENU.CANCEL' | translate }}
    </button>
  </div>
</div>
